import BaseAnalysisService from './BaseAnalysisService';
import env from 'environment';

class CrAnalysisService
    extends BaseAnalysisService {
  constructor() {
    super({
      analysisType: 'cr',
      requireAnalysisTypeId: false,
    });
  }
}

const service = new CrAnalysisService();

export default service;
